<div fxLayout="column">
    <div style="font-size: x-large; font-weight: 400;" class="my-2">{{"quotation_list"|translate}}</div>
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayout.xs="column">
    <div style="font-size: large; color: rgb(75, 71, 71);"  class="mb-3">{{"confirm_quotation_details"|translate}}</div>
    <button type="button" *ngIf="showCarts()" (click)="clearCart()" fxFlexAlign.xs="end"
               class="btn btn-primary my-2" style="overflow-wrap: break-word;

             "> {{"clear_request"|translate}} </button>
    </div>

    <div *ngIf="showCarts()">
    <div *ngFor="let cart of  quotationCart.qCart">
    <app-quotation-vendorContainer [cart]="cart"></app-quotation-vendorContainer></div>
</div>

</div>

